const USER_ROLE_MEDICAL_STANDARD = "MEDICAL STANDARD"
const USER_ROLE_MEDICAL_ADMIN = "MEDICAL ADMIN"
const USER_ROLE_MEDICAL_SUPER = "MEDICAL SUPER"
const USER_ROLE_EDUCATION_STANDARD = "EDUCATION STANDARD"
const USER_ROLE_EDUCATION_ADMIN = "EDUCATION ADMIN"
const USER_ROLE_EDUCATION_SUPER = "EDUCATION SUPER"
const USER_ROLE_SUPPORT_ADMIN = "SUPPORT ADMIN"

//DEFINE SOME RULES
const hasRoleAccess = (
    roles: string[],
    {
        any = [],
        all = [],
        none = [],
    }: {
        any?: string[];
        all?: string[];
        none?: string[];
    }
): boolean =>
    any.some(role => roles.includes(role)) &&
    all.every(role => roles.includes(role)) &&
    none.every(role => !roles.includes(role));

const allHaveAccess = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_STANDARD, USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_SUPER, USER_ROLE_MEDICAL_ADMIN, USER_ROLE_EDUCATION_ADMIN, USER_ROLE_EDUCATION_STANDARD, USER_ROLE_SUPPORT_ADMIN],
        none: [],
    })
};
const canExpireStudent = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_STANDARD, USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_SUPER],
        none: [USER_ROLE_MEDICAL_ADMIN, USER_ROLE_EDUCATION_ADMIN, USER_ROLE_EDUCATION_STANDARD, USER_ROLE_SUPPORT_ADMIN],
    })
};

const canViewInsights = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_SUPER, USER_ROLE_EDUCATION_ADMIN, USER_ROLE_SUPPORT_ADMIN],
        none: [USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_STANDARD
            , USER_ROLE_EDUCATION_STANDARD,],
    })
};

const canEditCompanyInfo = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_SUPER],
        none: [USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_STANDARD, USER_ROLE_EDUCATION_ADMIN
            , USER_ROLE_EDUCATION_STANDARD, USER_ROLE_SUPPORT_ADMIN],
    })
}

const canViewAllReports = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_SUPER, USER_ROLE_EDUCATION_ADMIN, USER_ROLE_EDUCATION_STANDARD, USER_ROLE_SUPPORT_ADMIN],
        none: [USER_ROLE_MEDICAL_STANDARD,],
    })
}
const canMakeReferral = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_SUPER, USER_ROLE_EDUCATION_ADMIN],
        none: [USER_ROLE_MEDICAL_STANDARD, USER_ROLE_EDUCATION_STANDARD, USER_ROLE_SUPPORT_ADMIN],
    })
}
const canBeAssignedStudent = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_STANDARD, USER_ROLE_EDUCATION_ADMIN],
        none: [USER_ROLE_MEDICAL_STANDARD, USER_ROLE_EDUCATION_SUPER, USER_ROLE_SUPPORT_ADMIN],
    })
}
const canBulkLaunch = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_EDUCATION_STANDARD, USER_ROLE_EDUCATION_SUPER, USER_ROLE_EDUCATION_ADMIN],
        none: [USER_ROLE_MEDICAL_STANDARD, USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_SUPER, USER_ROLE_SUPPORT_ADMIN],
    })
}
const canViewStaff = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_STANDARD, USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_SUPER, USER_ROLE_EDUCATION_ADMIN, USER_ROLE_SUPPORT_ADMIN],
        none: [USER_ROLE_EDUCATION_STANDARD],
    })
}

const canLaunchSingle = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_STANDARD, USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_SUPER, USER_ROLE_EDUCATION_ADMIN, USER_ROLE_EDUCATION_STANDARD],
        none: [USER_ROLE_SUPPORT_ADMIN],
    })
}
const canAddStudentAndStaff = (roles: string[]) => {
    return hasRoleAccess(roles, {
        any: [USER_ROLE_MEDICAL_STANDARD, USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_SUPER, USER_ROLE_EDUCATION_SUPER, USER_ROLE_EDUCATION_ADMIN, USER_ROLE_EDUCATION_STANDARD],
        none: [USER_ROLE_SUPPORT_ADMIN],
    })
}

export {
    USER_ROLE_EDUCATION_ADMIN, USER_ROLE_EDUCATION_STANDARD, USER_ROLE_EDUCATION_SUPER,
    USER_ROLE_MEDICAL_ADMIN, USER_ROLE_MEDICAL_STANDARD, USER_ROLE_MEDICAL_SUPER,
    USER_ROLE_SUPPORT_ADMIN, hasRoleAccess, canEditCompanyInfo, canExpireStudent, canViewInsights, canViewAllReports,
    canMakeReferral, canBulkLaunch, allHaveAccess, canViewStaff, canLaunchSingle, canAddStudentAndStaff,
    canBeAssignedStudent
}